<div class="container" style="width: 65%;">
    <H1>Allocate Clients</H1>

    <div *ngIf="firstscreen">
        <div class="form-group">
            <label>Enter Box Number:</label>
            <input class="form-control" name="BoxNumber" type="text" [(ngModel)]="BoxNumber" required
                placeholder="Enter Box Number" maxlength="30"
                style="max-width: 400px; margin-left: auto;margin-right: auto;" (keyup)="BoxNameChanged($event)" />

            <label style="margin-top: 20px;">Existing Boxes:</label>
            <select class="selectpicker form-control" multiple="true"
                style="max-width: 400px;padding-bottom: 0px;margin-left: auto;margin-right: auto;"
                [(ngModel)]="PossibleBox" (change)="PossibleBoxChanged()">
                <option *ngFor="let item of PossibleBoxNumbers; let i =index" value={{item}}>{{item}}
                </option>
            </select>
        </div>


        <div class="form-group  form-button-div">

            <div style="float: left;margin-right: 20px;margin-left:20px;">
                <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="Reset()">Reset</button>
            </div>

            <div style="float: right;margin-left:20px;">
                <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!BoxNumber"
                    (click)="Next()">Next</button>
            </div>

        </div>




    </div>


    <div *ngIf="Secondscreen">
        <div class="form-group">
            <label>Box Number: {{BoxNumber}}</label><br>
            <label>Province: {{Province}}</label><br>
            <label style="font-weight: normal; font-size: 0.95em;">{{CompletedSummary}}</label><br>
        </div>

        <div class="row">
            <div class="col-6" *ngFor="let item of [].constructor(BoxNumberBatchsize); let i = index"
                style="padding-bottom: 20px;padding-top: 20px;">
                <h1>Batch: {{i+1}}</h1>
                <div style="text-align: left;">
                    <label>Select Area:</label>
                    <div style="display: flex;">
                        <select class="form-control" name="Area" type="text" [(ngModel)]="InputAreas[i]" required
                            placeholder="Enter Area" (change)="AreaChanged(i)">
                            <option *ngFor="let Area of Areas; let i =index" value={{Area}}>{{Area}}
                            </option>
                        </select>

                        <button class="form-control btn-primary" style="width: 200px;margin-left:10px;" type="submit"
                            (click)="AddNewArea()">Add Area</button>

                    </div>

                    <label style="padding-top: 10px;">Select Client:</label>

                    <div style="display: flex;">
                        <select class="form-control" name="Client" type="text" [(ngModel)]="InputClients[i]" required
                            placeholder="Enter Client">
                            <option *ngFor="let Client of Clients[i]; let i =index" value={{Client}}>{{Client}}
                            </option>
                        </select>

                        <button class="form-control btn-primary" style="width: 200px;margin-left:10px;" type="submit"
                            (click)="AddNewClient()">Add Client</button>

                    </div>


                    <label style="padding-top: 10px;">Select Date Of Distribution:</label>
                    <div style="display: flex;">
                        <input class="form-control" name="date" type="date" [(ngModel)]="InputDate[i]" required
                            placeholder="Select a date" (change)="DateChanged(i)" (focus)="SetDateIfEmpty(i)" [min]="MinDateOption"
                            max={{CurrentDate}} style="width: 66%;" />
                    </div>

                </div>

            </div>



        </div>




        <div class="form-group  form-button-div">

            <div style="float: left;margin-right: 20px;margin-left:20px;">
                <button class="btn btn-primary btn-lg btn-block" type="submit" (click)="Reset()">Back</button>
            </div>

            <div style="float: left;margin-right: 20px;margin-left:20px;">
                <button class="btn btn-warning btn-lg btn-block" type="submit" (click)="ResetClients()" >Reset</button>
            </div>

            <div style="float: right;margin-left:20px;">

                <button class="btn btn-success btn-lg btn-block" type="submit" *ngIf="this.confirmed === false"
                    (click)="Done()" >Confirm</button>
                <button class="btn btn-success btn-lg btn-block" type="submit" *ngIf="this.confirmed === true"
                    (click)="Done()" >Save</button>
            </div>

        </div>




    </div>

</div>

<script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.9/angular.min.js">
</script>

<!--Error popup-->
<div style="float: right;margin-left:20px;">
    <button class="btn btn-success btn-lg btn-block" id="contentClientPopUpErrorButton"
        (click)="open(contentClientPopUp)" style="display: none;">
    </button>

    <button class="btn btn-success btn-lg btn-block" id="AddAreaButton" (click)="opentemplate(content2)"
        style="display: none;">
    </button>

    <button class="btn btn-success btn-lg btn-block" id="AddClientButton" (click)="opentemplate(content3)"
        style="display: none;">
    </button>
</div>


<ng-template #contentClientPopUp let-modal ID="Errormessage">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            {{PopupTitle}}
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">

            <span aria-hidden="true">

            </span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-group">
                <label for="dateOfBirth">
                    {{DisplayErrormessage}}
                </label>
            </div>


        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
            {{PopUpbtnText}}
        </button>


    </div>
</ng-template>

<ng-template #content2 let-modal ID="AddArea">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
        style="margin-left: auto;padding-right: 10px;">

        <span aria-hidden="true">
            ×
        </span>
    </button>

    <app-add-areas></app-add-areas>

    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
            Close Pop-Up
        </button>
    </div>
</ng-template>

<ng-template #content3 let-modal ID="Addclient">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"
        style="margin-left: auto;padding-right: 10px;">

        <span aria-hidden="true">
            ×
        </span>
    </button>

    <app-add-client AlloCateClientPopupVersion={{true}} PreselectedProvince={{this.Province}}
        PreselectedArea={{this.InputAreas[1]}}></app-add-client>

    <div class="modal-footer">
        <button type="button" class="btn btn-success btn-lg btn-block" (click)="modal.close('Save click')">
            Close Pop-Up
        </button>
    </div>
</ng-template>